import React, {
  useState,
  useEffect,
  useReducer,
  useRef,
  useCallback,
  useMemo,
} from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
} from '@material-ui/core';
import { Spinner } from '../../../../../../Components';

import { showSuccess, showError } from '../../../../../../Helper';
import { UpdateAgreementDetailsAPI } from '../../../../../../Services';
import {
  AgreementDetailsContentDialog,
  AgreementDetailsManagementComponents,
} from '.';
import { FooterWrapperComponent } from '../../../VendorsUtilities/Components/FooterWrapperComponent';
// import { AgreementDetailsManagementComponents } from '../../../../DevelopersView/DeveloperTabsSections/AgreementsAndCompliance';
// import { AgreementDetailsManagementComponents } from '../../../../DevelopersView/DeveloperTabsSections/AgreementsAndCompliance';

const reducer = (select, action) => {
  if (action.id !== 'edit') return { ...select, [action.id]: action.value };
  if (action.id === 'edit') {
    return {
      ...action.value,
    };
  }
};
export const AgreementDetailsManagementDialog = ({
  parentTranslationPath,
  translationPath,
  isOpen,
  onClose,
  onSave,
  agreementDetailsValues,
  contactReletedWithDeveloperId,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const [isLoading, setIsLoading] = useState({
    agreementsTypes: false,
    addAgreementDetails: false,
    branches: false,
    users: false,
    info: [],
    properties: false,
    editAgreementDetails: false,
  });

  const defaultState = useMemo(
    () => ({
      developerContactId: null,
      agreementDetailsId: null,
      agreementTypeId: null,
      agreementStartDate: null,
      agreementDuration: null,
      agreementEndDate: null,
      isMarketingBudgetAllocation: false,
      marketingBudgetAmount: null,
      agreementDetailsProjects: [],
      agreementDetailsSigningBranches: [],
      agreementDetailsAuthorizedSignatories: [],
      agreementStatusId: null,
    }),
    []
  );

  const defaultSelected = useMemo(
    () => ({
      agreementType: null,
      marketingBudgetAllocation: null,
      agreementDetailsProjects: [],
      agreementDetailsSigningBranches: [],
      agreementDetailsAuthorizedSignatories: [],
      agreementsStatus: null,
    }),
    []
  );

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={(_e, reason) => {
          if (reason !== 'backdropClick') {
            onClose();
          }
        }}
        className='activities-management-dialog-wrapper'
        maxWidth='sm'
      >
        <DialogTitle id='alert-dialog-slide-title'>
          <span>{t(`edit-agreement-details`)}</span>
        </DialogTitle>
        <DialogContent>
          <AgreementDetailsManagementComponents
            parentTranslationPath={parentTranslationPath}
            activeItem={agreementDetailsValues}
            className={'dialog-content-item'}
            onClose={onClose}
            onSave={onSave}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

AgreementDetailsManagementDialog.propTypes = {
  parentTranslationPath: PropTypes.string.isRequired,
  translationPath: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  editPortalConfiguration: PropTypes.instanceOf(Object),
  isLoading: PropTypes.instanceOf(Object),
};
AgreementDetailsManagementDialog.defaultProps = {
  editPortalConfiguration: undefined,
  isLoading: undefined,
};
